'use client';
import clsx from 'clsx';
import React from 'react';
import { factory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { useId } from '../../Inputs/Dropdown/subcomponent/Combobox/use-id.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import { Tooltip } from '../../Popover/Tooltip/Tooltip.mjs';
import { useCheckboxGroupContext } from './Checkbox.context.mjs';
import classes from './Checkbox.module.css.mjs';
import { CheckboxIcon } from './CheckboxIcon.mjs';

const ConditionalWrapper = ({ tooltip, className, children, ...rest }) => {
  if (tooltip) {
    return /* @__PURE__ */ React.createElement(Box, { className, ...rest }, /* @__PURE__ */ React.createElement(Tooltip, { ...tooltip }, children));
  }
  return /* @__PURE__ */ React.createElement(Box, { className, ...rest }, children);
};
const Checkbox = factory((props, ref) => {
  const { className, style, id, label, disabled, onChange, indeterminate, checked, tooltip, ...rest } = props;
  const ctx = useCheckboxGroupContext();
  const inputId = useId(id);
  const contextProps = ctx ? {
    checked: ctx.value.includes(rest.value),
    onChange: (event) => {
      ctx.onChange(event);
      onChange?.(event);
    }
  } : {};
  return /* @__PURE__ */ React.createElement(
    ConditionalWrapper,
    {
      className: clsx(className, "kohler-checkbox-root", classes.checkboxWrapper),
      style,
      "data-checked": contextProps.checked || checked || void 0,
      tooltip
    },
    /* @__PURE__ */ React.createElement(Box, { className: classes.checkboxContainer }, /* @__PURE__ */ React.createElement(Box, { className: clsx("kohler-checkbox-radio", classes.checkboxInner) }, /* @__PURE__ */ React.createElement(
      Box,
      {
        onChange,
        className: clsx("kohler-checkbox-radio-input", classes.checkboxInput),
        component: "input",
        ref,
        id: inputId,
        disabled,
        checked,
        ...rest,
        ...contextProps,
        type: "checkbox"
      }
    ), /* @__PURE__ */ React.createElement(CheckboxIcon, { "aria-hidden": true, className: classes.checkboxIcon, indeterminate })), /* @__PURE__ */ React.createElement("div", { "data-disabled": disabled || void 0, className: classes.checkboxLabelWrapper }, label && /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: "label",
        htmlFor: inputId,
        size: "label-regular-m",
        className: classes.checkboxLabel,
        "data-disabled": disabled || void 0
      },
      label
    )))
  );
});

export { Checkbox };
